module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"category":"Category","items":"Items","weight":"Weight"},"de":{"category":"Kategorie","items":"Anzahl","weight":"Gewicht"}}')
  delete Component.options._Ctor
}
